module.exports = __webpack_public_path__ + "img/experience02.d5dadabe.jpg";